import React from "react";

const ButtonText = ({ variant, children, className = "" }) => {
  return (
    <>
    {/* o	Usage: Main actions like 'Sign Up', 'Contact Us', 'Buy Now' */}
      {variant === "PrimaryText" && (
        <p
          className={`
          ${className} primary-button font-inter normal-case`}
        >
          {children}
        </p>
      )}

      {variant === "SecondaryButton" && (
        <p
          className={`
          ${className} secondary-button font-inter normal-case`}
        >
          {children}
        </p>
      )}

      {variant === "MicroInteraction" && (
        <p
          className={`
          ${className} micro-interaction font-inter normal-case`}
        >
          {children}
        </p>
      )}

      {/* Link CTA — inline actions like 'Look Up (ABN)', 'Read more' */}
      {variant === "SecondaryText" && (
        <p
          className={`
          ${className} link-cta font-inter normal-case`}
        >
          {children}
        </p>
      )}
    </>
  );
};
export default ButtonText;
